
/* eslint-disable max-classes-per-file */

export class LagermalResponseDTO   {

    lagermal: LagermalDTO[];
    marknadsomradeId: number;
    period: string;
    produktionsomradeId: number;

    constructor() {
        this.lagermal = undefined;
        this.marknadsomradeId = undefined;
        this.period = undefined;
        this.produktionsomradeId = undefined;
    }
}
export class LagermalDTO   {

    apr: LagermalPeriod;
    aug: LagermalPeriod;
    dec: LagermalPeriod;
    enterQuantity: boolean;
    feb: LagermalPeriod;
    handelssortiment: string;
    id: number;
    inherited: boolean;
    inheritedFrom: InheritedFrom;
    jan: LagermalPeriod;
    jul: LagermalPeriod;
    jun: LagermalPeriod;
    lagermal: LagermalDTO[];
    lagermalTyp: string;
    maj: LagermalPeriod;
    mar: LagermalPeriod;
    nov: LagermalPeriod;
    okt: LagermalPeriod;
    perioder: LagermalPeriod[];
    handelssortimentsgrupp: string;
    sep: LagermalPeriod;
    standardVarde: number;
    toolTip: string;
    moStandardVarde: number;

    constructor() {
        this.apr = undefined;
        this.aug = undefined;
        this.dec = undefined;
        this.enterQuantity = undefined;
        this.feb = undefined;
        this.handelssortiment = undefined;
        this.id = undefined;
        this.inherited = undefined;
        this.inheritedFrom = undefined;
        this.jan = undefined;
        this.jul = undefined;
        this.jun = undefined;
        this.lagermal = undefined;
        this.lagermalTyp = undefined;
        this.maj = undefined;
        this.mar = undefined;
        this.nov = undefined;
        this.okt = undefined;
        this.perioder = undefined;
        this.handelssortimentsgrupp = undefined;
        this.sep = undefined;
        this.standardVarde = undefined;
        this.toolTip = undefined;
        this.moStandardVarde = undefined;
    }
}
export class LagermalPeriod   {

    active: boolean;
    enterQuantity: boolean;
    hasPassed: boolean;
    id: number;
    inheritedFrom: InheritedFrom;
    kvantitet: number;
    lagermal: number;
    month: number;
    overridden: boolean;
    toolTip: string;
    year: number;

    constructor() {
        this.active = undefined;
        this.enterQuantity = undefined;
        this.hasPassed = undefined;
        this.id = undefined;
        this.inheritedFrom = undefined;
        this.kvantitet = undefined;
        this.lagermal = undefined;
        this.month = undefined;
        this.overridden = undefined;
        this.toolTip = undefined;
        this.year = undefined;
    }
}

export enum InheritedFrom {
 Not = 0,
 MOHg = 1,
 MOHS = 2,
 MOHgMonth = 3,
 MOHSMonth = 4,
 POHg = 5,
 POHS = 6,
 POHgMonth = 7,
 POHSMonth = 8,
}
